import React, { Component, useState } from "react";
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  BooleanField,
  EditButton,
  TextField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  useRecordContext,
  usePermissions,
  useResourceContext,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { Scrollbars } from "react-custom-scrollbars";
import {
  getLocalStorageKey,
  CommonHeaderOption,
  RUN_TIME_API_ENDPOINT,
} from "../common/common";
import { useLocation } from "react-router-dom";
// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = () => {
  const resource = useResourceContext();
  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const record = useRecordContext();
  return record && <span>Send Message&nbsp;</span>;
};

const SendMessageShow = (props) => {
  const [loadingShow, setLoadingShow] = useState(false);

  const permissions = usePermissions();
  const location = useLocation();
  console.log("location......", location);
  const pathSplit = location.pathname.split("/");
  console.log("location......pathSplit", pathSplit);
  const smsMessageId = pathSplit[2];

  return (
    <Show actions={<ShowActions />} title={<ShowTitle />}>
      <TabbedShowLayout className="tab-scroll">
        <Tab label="Details" contentClassName="scrollTab">
          <TextField label="Purpose" source="purpose" allowEmpty />
          <TextField label="SMS Text" source="text" allowEmpty />
          <TextField label="Target type" source="type" allowEmpty />
          <TextField
            label="SMS length [eg. 2 (160 characters)]"
            source="sms_length"
            sortable={false}
            allowEmpty
          />
          <TextField
            label="Number of Sold tos"
            source="targeted_businesses_count"
          />
          <TextField
            label="Number of SMS (Number of Sold tos * SMS length)"
            source="number_of_messages"
          />
          <TextField
            label="Number of SMS sent successfully"
            source="notified_businesses_count"
          />
          <TextField
            label="Number of SMS sending failed"
            source="failed_businesses"
            allowEmpty
          />
          {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
          <DateField label="Created At" source="created_at" showTime />
        </Tab>
        <Tab label="Sold To List">
          <ReferenceManyField
            label=""
            addLabel={false}
            reference="sms_blast_sold_to_list"
            target="id"
            className="tab-pagination"
          >
            <List
              actions={false}
              filterDefaultValues={{ id: smsMessageId }}
              exporter={false}
            >
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                <TextField label="Sold To ID" source="sap_code" />
                <TextField label="Sold To Name" source="name" />
                <TextField label="User Phone" source="phone" />
                <ReferenceField
                  label="User name"
                  source="user_id"
                  reference="users"
                  link="show"
                  allowEmpty
                >
                  <TextField source="first_name" />
                </ReferenceField>
                {/* <ReferenceField label="Sold To Phone" source="phone" /> */}
                <BooleanField label="SMS status" source="send_status" />
                <TextField label="SMS response" source="send_response" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default SendMessageShow;
